import type { BadgeProps } from '../ui/badge';
import type { ListingStatus } from '../../lib/leasing.api';

/** Display labels for a listing's lifecycle status (shared by the index and detail pages). */
export const LISTING_STATUS_LABELS: Record<ListingStatus, string> = {
  draft: 'Draft',
  active: 'Active',
  paused: 'Paused',
  closed: 'Closed',
};

/** Shared Badge variant per listing status — the single source of status colour semantics. */
export const LISTING_STATUS_BADGE_VARIANTS: Record<ListingStatus, BadgeProps['variant']> = {
  draft: 'secondary',
  active: 'success',
  paused: 'warning',
  closed: 'danger',
};
